import React, { Component } from "react"
import { connect } from "react-redux"
import "bootstrap/dist/css/bootstrap.min.css"
import "font-awesome/css/font-awesome.min.css"
import "./App.css"
import "bootstrap/dist/js/bootstrap.bundle.min"

import Auth from "./auth/Auth"
import App from "./App"
import "./Style.css"

class AuthOrApp extends Component {
    constructor(props) {
         super(props)
         this.state = { tiraroerrocompilacao: 0 }
    }

    render() {
        const { access_token } = this.props.auth
        if (!access_token) {
            return <Auth />
        }
        else {
            return <App />
        }

    }
}

const mapStateToProps = state => ({ auth: state.authRed })
export default connect(mapStateToProps, null)(AuthOrApp)